import { PremierCollectionCheckoutBenefits } from "./component";

export default PremierCollectionCheckoutBenefits;
